export const MESSAGE_TYPE = {
    TEXT: 0,
    IMAGE: 1,
    VIDEO: 2,
    AUDIO: 3,
    FILE: 4
};